import * as React from "react";
import { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Link,
  Paper,
} from "@mui/material";

import PageContainer from "src/components/container/PageContainer";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import ParentCard from "src/components/shared/ParentCard";
import VehicleDetailsService from "src/service/vehicleDetails";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import PinDropSharpIcon from "@mui/icons-material/PinDropSharp";
import MapIcon from "@mui/icons-material/Map";

import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Vehicle List",
  },
];

const VehichleListView = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));

  const [vehichleList, setVehichleList] = React.useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredVehichleList, setFilteredVehichleList] = useState([]);

  const fetchVehicleDetails = async () => {
    try {
      const res = await VehicleDetailsService.getVehicleDetails({});
      setVehichleList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    // Filter the vehicle list based on the search query
    const filteredList = vehichleList.filter(
      (vehicle) =>
        vehicle.vehicle_name
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        vehicle.make.toLowerCase().includes(searchQuery.toLowerCase()) ||
        vehicle.vehicle_no.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (vehicle.imei_no &&
          vehicle.imei_no.toLowerCase().includes(searchQuery.toLowerCase())) ||
        vehicle.model.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredVehichleList(filteredList);
  }, [searchQuery, vehichleList]);

  useEffect(() => {
    fetchVehicleDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  // ====================================
  return (
    <PageContainer title="Vehicle List" description="this is Basic Table page">
      {/* breadcrumb */}
      <Breadcrumb title="Vehicle List" items={BCrumb} />
      {/* end breadcrumb */}

      <Box sx={{ display: "flex", alignItems: "center", mt: 2, mb: 2 }}>
        <SearchIcon sx={{ color: "action.active", mr: 1, my: 0.5 }} />
        <InputBase
          placeholder=" Search here ....... "
          value={searchQuery}
          onChange={handleSearchChange}
          sx={{ width: "40%", border: "1px solid #8080802e" }}
        />
      </Box>

      <ParentCard title="">
        <Box>
          <Box>
            <Paper variant="outlined" sx={{ mx: 2, mt: 1 }}>
              <TableContainer>
                <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        width={"10%"}
                        style={{ fontWeight: "700", fontSize: "14px" }}
                      >
                        Sl. No.
                      </TableCell>
                      <TableCell
                        style={{ fontWeight: "700", fontSize: "14px" }}
                      >
                        Vehichle Name / Number
                      </TableCell>
                      {/* <TableCell style={{fontWeight: "700", fontSize: "14px"}}>
                        Vehicle ID
                      </TableCell> */}
                      <TableCell
                        style={{ fontWeight: "700", fontSize: "14px" }}
                      >
                        IMEI No.
                      </TableCell>
                      <TableCell
                        style={{ fontWeight: "700", fontSize: "14px" }}
                      >
                        Status
                      </TableCell>
                      <TableCell
                        style={{ fontWeight: "700", fontSize: "14px" }}
                      >
                        Make / Model
                      </TableCell>
                      {/* <TableCell style={{fontWeight: "700", fontSize: "14px"}}>
                        Model
                      </TableCell> */}
                      <TableCell
                        style={{ fontWeight: "700", fontSize: "14px" }}
                      >
                        Replay
                      </TableCell>
                      <TableCell
                        style={{ fontWeight: "700", fontSize: "14px" }}
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {filteredVehichleList.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={3} style={{ textAlign: "center" }}>
                          <Typography
                            style={{ fontSize: "13px" }}
                            variant="h6"
                            sx={{ color: "red" }}
                          >
                            No records found!!
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      filteredVehichleList.map((val, index) => (
                        <TableRow key={val.id} hover>
                          <TableCell>
                            <Typography
                              variant="h6"
                              fontWeight="600"
                              fontSize={"12px"}
                            >
                              {index + 1}
                            </Typography>
                          </TableCell>

                          <TableCell>
                            <Box display="flex" alignItems="center">
                              {/* <Avatar
                                src={`http://localhost:3000/static/media/s1.d7f18cccfab086a0e961.jpg`}
                                alt={`http://localhost:3000/static/media/s1.d7f18cccfab086a0e961.jpg`}
                                variant="rounded"
                                sx={{ width: 56, height: 56, borderRadius: '100%' }}
                              /> */}
                              <Box
                                sx={{
                                  ml: 2,
                                }}
                              >
                                <Typography
                                  textAlign={"center"}
                                  variant="h6"
                                  fontWeight="600"
                                  fontSize={"12px"}
                                >
                                  {val.vehicle_name}
                                </Typography>
                                <Typography
                                  color="textSecondary"
                                  variant="subtitle2"
                                  fontSize={"12px"}
                                >
                                  {val.vehicle_no}
                                </Typography>
                              </Box>
                            </Box>
                          </TableCell>

                          <TableCell>
                            <Typography
                              color="textSecondary"
                              variant="subtitle2"
                              fontSize={"12px"}
                            >
                              {val.imei_no}
                            </Typography>
                            {/* <Typography fontSize={"12px"}>{format(new Date(), 'E, MMM d yyyy')}</Typography> */}
                          </TableCell>

                          <TableCell>
                            <Box display="flex" alignItems="center">
                              <Box
                                sx={{
                                  background: "green",
                                  // backgroundColor: row.stock
                                  //   ? (theme) => theme.palette.success.main
                                  //   : (theme) => theme.palette.error.main,
                                  borderRadius: "100%",
                                  height: "10px",
                                  width: "10px",
                                }}
                              />
                              <Typography
                                color="textSecondary"
                                variant="subtitle2"
                                sx={{
                                  ml: 1,
                                }}
                                fontSize={"12px"}
                              >
                                Active
                                {/* {row.stock ? 'InStock' : 'Out of Stock'} */}
                              </Typography>
                            </Box>
                          </TableCell>

                          <TableCell>
                            <Typography
                              fontWeight="500"
                              variant="h6"
                              fontSize={"12px"}
                            >
                              {val.make} | {val.model}
                            </Typography>
                          </TableCell>
                          {/* <TableCell >
                            <Typography fontWeight="500" variant="h6" fontSize={"12px"}>
                            {val.model}
                            </Typography>
                          </TableCell> */}
                          <TableCell>
                            <Typography
                              fontWeight="500"
                              variant="h6"
                              fontSize={"12px"}
                            >
                              -
                            </Typography>
                          </TableCell>
                          {sessionData.data.user_type === 1 && (
                            <TableCell style={{ textAlign: "center" }}>
                              <Link to={``}>
                                <AssignmentIndOutlinedIcon
                                  style={{
                                    color: "blue",
                                    fontSize: "18px",
                                    cursor: "pointer",
                                  }}
                                />
                              </Link>

                              <Link to={``}>
                                <PinDropSharpIcon
                                  style={{
                                    color: "blue",
                                    fontSize: "18px",
                                    cursor: "pointer",
                                  }}
                                />
                              </Link>

                              <Link to={``}>
                                <MapIcon
                                  style={{
                                    color: "blue",
                                    fontSize: "18px",
                                    cursor: "pointer",
                                  }}
                                />
                              </Link>
                            </TableCell>
                          )}
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Box>
        </Box>
      </ParentCard>
    </PageContainer>
  );
};

export default VehichleListView;
